import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CopyButton } from '@/components/ui/copy-button';
import { Terminal } from 'lucide-react';
import { generateEdgeLinkUninstallCommand } from '@/lib/api/edgelink';

interface UninstallEdgeLinkModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function UninstallEdgeLinkModal({
  open,
  onOpenChange,
}: UninstallEdgeLinkModalProps) {
  const uninstallCommand = generateEdgeLinkUninstallCommand();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-2rem)] max-w-2xl p-0 gap-0">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-[#2E3835]">
          <DialogTitle>Uninstall EdgeLink</DialogTitle>
          <DialogDescription className="p-0 mt-1.5">
            Run this command as root on the device to uninstall the EdgeLink agent.
          </DialogDescription>
        </DialogHeader>

        <div className="p-6 space-y-4">
          <div className="space-y-3">
            <div className="flex items-center gap-2 text-sm font-medium">
              <Terminal className="h-4 w-4 text-lime" />
              <span>Uninstall Command</span>
            </div>

            <div className="relative">
              <div className="bg-zinc-950 text-zinc-100 px-4 py-3 rounded-lg text-sm font-mono border border-zinc-800 pr-12 overflow-x-auto">
                <code className="whitespace-pre-wrap break-all leading-relaxed">
                  {uninstallCommand}
                </code>
              </div>
              <div className="absolute top-2 right-2">
                <CopyButton textToCopy={uninstallCommand} label="Command" />
              </div>
            </div>

            <p className="text-xs text-muted-foreground">
              This will remove the EdgeLink agent and all associated configurations from the device.
            </p>
          </div>

        </div>

        <div className="flex justify-end px-6 py-4 border-t border-[#2E3835]">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
